// @ts-nocheck
import { OrderStateContext } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import React, { FC, useContext } from "react";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import GridContainer, { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import Typography, { TypographyPresentationProps } from "@store/MobiusOverrides/Typography/Typography";
import translate from "@insite/client-framework/Translate";
import { orderV2Props } from "@store/Themes/common/props/orderV2";
import { css } from "styled-components";
import mergeProps from "@toolkit/Framework/Common/Utilities/mergeProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import InlineAddress from "@store/Library/Components/InlineAddress";

interface OrderDetailsShippingInformationProps extends WidgetProps {}

export interface OrderDetailsShippingInformationStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    addressTitle?: TypographyPresentationProps;
    wrapper?: InjectableCss;
    boxWrapper?: InjectableCss;
    sectionTitle?: TypographyPresentationProps;
}

export const orderDetailsShippingInformationStyles: OrderDetailsShippingInformationStyles = {
    gridContainer: {
        gap: 16,
    },
    gridItem: orderV2Props.addressGridItem,
    addressTitle: orderV2Props.infoLabel,
    wrapper: orderV2Props.sectionWrapper,
    boxWrapper: orderV2Props.boxWrapper,
    sectionTitle: orderV2Props.sectionTitle,
};

const styles = orderDetailsShippingInformationStyles;

const OrderDetailsShippingInformation: FC<OrderDetailsShippingInformationProps> = () => {
    const { value: order } = useContext(OrderStateContext);

    if (!order) {
        return null;
    }

    const hasShippingAddress = order.fulfillmentMethod === FulfillmentMethod.Ship || !order.fulfillmentMethod;

    return (
        <StyledWrapper {...styles.wrapper}>
            <Typography {...styles.sectionTitle}>{translate("Shipping Information")}</Typography>
            <StyledWrapper {...styles.boxWrapper}>
                <GridContainer {...styles.gridContainer}>
                    <GridItem {...styles.gridItem}>
                        <Typography {...styles.addressTitle}>{translate("Sold-To Information")}</Typography>
                        <InlineAddress billTo={order} />
                    </GridItem>
                    <GridItem {...styles.gridItem}>
                        <Typography {...styles.addressTitle}>
                            {translate(hasShippingAddress ? "Shipping Information" : "Pick Up Location")}
                        </Typography>
                        <InlineAddress shipTo={order} />
                    </GridItem>
                </GridContainer>
            </StyledWrapper>
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: OrderDetailsShippingInformation,
    definition: {
        group: "Order Details",
        displayName: "Shipping Information",
        allowedContexts: ["OrderDetailsPage", "VmiOrderDetailsPage"],
    },
};

export default widgetModule;
